import { render, staticRenderFns } from "./user-cards.vue?vue&type=template&id=fcd968a0&"
import script from "./user-cards.vue?vue&type=script&lang=js&"
export * from "./user-cards.vue?vue&type=script&lang=js&"
import style0 from "./user-cards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports